module.exports = __webpack_public_path__ + "static/media/success.4915d3a3.png";